<div class="example-container mat-elevation-z8" *ngIf="parentData">
  
    <div fxLayout="row" fxLayoutAlign="start center" fxFlex="1 0 auto">
    
        
      <i *ngIf="datatableProp.isAdd" class="material-icons md-48" 
        style="color: #02488e;margin-left: 24px;font-size: 32px;cursor:pointer;margin-top: -12px !important;" 
          color="accent" (click)="addRecord()">
        add_box
      </i>
        
      <mat-form-field style="margin-left: 50px;">
         
        <input matInput (keyup)="applyFilter($event.target.value)" [(ngModel)]="parent.filterText">
        <mat-placeholder><mat-icon>search</mat-icon></mat-placeholder>
      </mat-form-field>
      <div fxFlex="5"></div>
    </div>
    <mat-table [dataSource]="dataSource" matSort (matSortChange)="sortData($event,this)" [matSortActive]="parent.sortHeaderName" [matSortStart]="parent.sortDirection">
  
      <div *ngFor="let cols of displayedColumns" >
         
        <ng-container [matColumnDef]="cols" *ngIf="cols == 'Edit'">
          <mat-header-cell *matHeaderCellDef class="ngCustomWidth"> </mat-header-cell>
          <mat-cell *matCellDef="let row" class="ngCustomWidth" >
            <mat-icon  style="font-size:18px;color:orange" (click)="editRecord($event)"  id="{{row['Id']}}">edit</mat-icon>
          </mat-cell>
        </ng-container>

        <ng-container [matColumnDef]="cols" *ngIf="cols == 'Delete'">
          <mat-header-cell *matHeaderCellDef class="ngCustomWidth">  </mat-header-cell>
          <mat-cell *matCellDef="let row" class="ngCustomWidth">
            <mat-icon style="font-size:18px;color:rgb(240, 98, 98)"  (click)="deleteRecord($event)" id="{{row['Id']}}">delete</mat-icon>
          </mat-cell>
        </ng-container> 

        <ng-container [matColumnDef]="cols" *ngIf="isCustomColumn(cols)">
         
            <mat-header-cell *matHeaderCellDef class="ngCustomWidth"></mat-header-cell>
            <mat-cell *matCellDef="let row" class="ngCustomWidth" matTooltip="{{getCustomControProp(cols,'ToolTip')}}">
                <mat-icon class="mat-icon material-icons {{getCustomControProp(cols,'Class')}}" 
                  (click)="customRecord($event)" id="{{row['Id']}}" 
                  style="font-size:18px;color: #02488e;">
                  {{getCustomControProp(cols,'Icon')}}</mat-icon> 
            </mat-cell>
        </ng-container>

      
        <ng-container [matColumnDef]="cols" *ngIf="cols != 'Edit' && cols != 'Delete' && !isCustomColumn(cols)">
          <mat-header-cell *matHeaderCellDef [mat-sort-header]="cols" [id]="cols" (click)="getColumnDetails($event)"> {{cols}} </mat-header-cell>
          <mat-cell *matCellDef="let row" class="truncate mat-cell-padding"> {{row[cols]}} </mat-cell>
        </ng-container>

      </div>
      <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
      <mat-row *matRowDef="let row; columns: displayedColumns;">
      </mat-row>
    </mat-table>
  
    <mat-paginator #paginator [length]="parent.length" [pageSizeOptions]="[10, 25, 50, 100]" (page)="getServerData($event)"></mat-paginator>
  </div>







// WEBPACK FOOTER //
// D:/Keval/Project/Mindport/HRS/hantraco-app/src/app/main/content/components/secondary-datatable/secondary-datatable.component.html